/*
 * Author: Harper Yan
 * File Created: Friday, 24-08-02 02:16 pm
 * Last Modified: Tuesday, 24-11-19 06:45 pm, by Roger
 */

// update from https://www.figma.com/design/w89XIcAJwfzL0E1KIJzPkq/DeCard%E8%A7%84%E8%8C%83?node-id=244-1214&node-type=canvas&m=dev
export default function Info() {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" data-sentry-element="svg" data-sentry-component="Info" data-sentry-source-file="index.tsx">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11 7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V7ZM13.2 16.1C13.2 16.7075 12.7075 17.2 12.1 17.2C11.4925 17.2 11 16.7075 11 16.1C11 15.4925 11.4925 15 12.1 15C12.7075 15 13.2 15.4925 13.2 16.1Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="index.tsx" />
    </svg>;
}